<template>
  <a-modal
    :visible="visible"
    @cancel="closeShareContatsModal"
    :footer="null"
    wrapClassName="share-contacts-modal"
  >
    <div class="share-contacts-container">
      <h2 class="share-contacts-container__title">
        Share with Contacts in Glocal
      </h2>
      <div class="share-contacts-container__body">
        <div class="form">
          <TagifyContacts
            ref="tagifyContacts"
            module="shareActNowLetter"
            :options="[]"
            @fetchSelection="updateConnectionList"
            @handle-search="handleSearch"
            placeholder="Please enter name"
          />
          <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
        </div>
        <a-button
          :loading="loading"
          class="share-contacts-container__body--btn"
          @click="shareLetter"
        >
          Share
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import TagifyContacts from "@/components/PdbComponents/TagifyContacts.vue";
import { mapActions } from "vuex"
export default {
  props: {
    visible: Boolean,
    chatId:{
      type: String,
      default: () => ('')
    },
    articleLink:{
      type: String,
      default: () => ('')
    }
  },
  components: {
    TagifyContacts,
  },
  watch: {
    visible(val) {
      if (!val) {
        this.emitter.emit("clear-tagify-contacts");
      }
    },
    connectSearchedList(val) {
      if (val.length === 0) {
        this.errorMessage = "";
      }
    },
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      connectSearchedList: [],
    };
  },
  emits: ["closeModal"],
  methods: {
    ...mapActions({
      shareLetterViaGlocal: 'discover/shareLetterViaGlocal',
    }),
    closeShareContatsModal() {
      this.loading = false;
      this.errorMessage = "";
      this.connectSearchedList = [];
      this.emitter.emit("clear-tagify-contacts");
      this.$emit("closeModal");
    },

    async inviteViaGlocal() {
      if (this.connectSearchedList.length === 0) {
        this.errorMessage = "This field is required.";
        return;
      }

      const usersToBeConnected = this.connectSearchedList.map((user) => {
        return {
          to_user: user.value,
          add_to_contributor: false,
          message: "",
        };
      });

      this.loading = true;
      this.errorMessage = "";

      try {
        await this.$store.dispatch("profile/sendUserRequest", {
          users: usersToBeConnected,
        });

        this.$showToast({ message: "Invitation sent.", type: "success" });
        this.closeShareContatsModal();
      } catch (err) {
        console.error("Error response:", err.response?.data);
        this.errorMessage =
          err.response?.data?.error || "Something went wrong.";
      } finally {
        this.loading = false;
      }
    },

    async shareLetter(){

      if (this.connectSearchedList.length === 0) {
        this.errorMessage = "Please select a contact to share the letter with.";
        return;
      }
      
      try{
        this.loading = true;
        this.errorMessage = "";
        const glocalContacts = this.connectSearchedList.map(user=>({to_user:user?.value, link:this.articleLink}))
        await this.shareLetterViaGlocal({chatId:this.chatId, userDetails:glocalContacts})
        this.closeShareContatsModal()
        this.$showToast({ message: "Letter shared successfully.", type: "success" });
      }
      catch(err){
        console.error("Error response:");
      }finally{
        this.loading = false;
      }
    },
    updateConnectionList(list) {
      this.connectSearchedList = list;
    },
    handleSearch(){
      this.errorMessage = ''
    }
  },
};
</script>

<style lang="scss">
.share-contacts-modal {
  .ant-modal {
    width: 50rem !important;
    top: 15rem;
    .ant-modal-content {
      padding: 2.5rem;
      box-shadow: 0px 0px 94px #00000047;
      background: #f6f8ff;
      border-radius: 0;
      .ant-modal-close {
        margin: 2.3rem 2rem 0 0;
      }
      .ant-modal-header {
        display: none;
      }
      .ant-modal-body {
        .share-contacts-container {
          &__title {
            font-size: 2.4rem;
            font-family: $font-secondary-bold;
            line-height: normal;
            margin-bottom: 2.5rem;
            padding-right: 2.5rem;
          }
          &__body {
            .form {
              .tagify {
                font-size: 1.4rem;
                font-family: $font-primary;
                border-radius: 0.5rem;
                border: 1px solid $color-dark-grey-4;
                &__input {
                  padding: 1.1rem 1rem;
                  font-size: 1.4rem;
                  &::before {
                    max-width: 87%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: $color-placeholder;
                  }
                }
                &__tag {
                  display: flex;
                  align-items: center;
                  margin: 0.3rem 0 0.2rem 0.3rem;
                  background-color: #e5e5e5;
                  border-radius: 0.5rem;
                  &:hover,
                  &:focus {
                    box-shadow: none;
                    background-color: #cfd7ef;
                  }
                  .tagify__tag__user {
                    .tagify__tag__avatar-wrap {
                      width: 2.6rem;
                      height: 2.4rem;
                    }
                    .tagify__tag-text {
                      font-size: 1.4rem;
                      line-height: 2rem;
                    }
                    &::before {
                      background-color: transparent;
                    }
                  }
                }
              }
            }
            .error {
              color: red;
              font-size: 1.4rem;
              font-family: $font-primary;
              margin: 0.7rem 0 0;
              line-height: 1.8rem;
            }
            &--btn {
              font-size: 1.6rem;
              font-family: $font-primary-medium;
              width: 9rem;
              margin-top: 5rem;
              display: block;
              margin-left: auto;
              height: 4rem;
              border: none;
              background-color: $color-primary;
              color: $color-white;
              padding: 0;
              span {
                line-height: normal;
              }
              &:hover,
              &:active,
              &:focus {
                background-color: $color-primary;
                color: $color-white;
              }
              span {
                line-height: normal;
              }
              .anticon {
                .anticon-spin {
                  font-size: 2rem;
                  color: $color-primary;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
